import state from './state';
import actions from './actions';
import createStore from './store';
import update from './update';

export default {
  install(application) {
    const store = createStore({
      state,
      actions,
      update,
    });
    application.provide('store', store);
    Object.assign(application.config.globalProperties, {
      store,
    });
  },
};
